module.exports = __webpack_public_path__ + "static/img/storageBottom1.eb91d43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storageBottom1.png
// module id = Hhvl
// module chunks = 2